import React, {Component} from 'react'

class MediaSidebar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      mediaCategories: [
        { name: '*', icon: 'fa fa-files-o fa-fw non-spin', 'title': 'All Items' },
        { name: 'image', icon: 'fa fa-picture-o fa-fw non-spin', 'title': 'Images' },
        { name: 'video', icon: 'fa fa-film fa-fw non-spin', 'title': 'Videos' },
        { name: 'audio', icon: 'fa fa-music fa-fw non-spin', 'title': 'Audios' },
        { name: 'attachment', icon: 'fa fa-paperclip fa-fw non-spin', 'title': 'Attachments' },
        { name: 'folders', icon: 'fa fa-folder-open-o fa-fw non-spin', 'title': 'Browse Folders' }
      ]
    }
  }

  render(){
    var logoUrl = pagebuilder_base + '/components/com_sppagebuilder/assets/img/logo-white.svg';
    return(
      <div className="sp-pagebuilder-media-modal-sidebar-inner">
        <div className="sp-pagebuilder-brand">
          <a href="#">
            <img src={ logoUrl }/>
            <span>PRO</span>
          </a>
        </div>
        <ul id="sp-pagebuilder-media-types">
          {
            this.state.mediaCategories.map((category, index) => {
              var activeClass = '';
                if ( category.name === this.props.browserMediaType ) {
                  activeClass = 'active';
                }

              return(
                <li
                  className={activeClass}
                  key={index}
                  onClick = { (e) => {
                    e.preventDefault();
                    this.props.onHandleCategoryChange(category.name);
                  }}
                >
                  <a href="#" className="sp-pagebuilder-browse-media">
                    <i className="fa fa-spinner fa-spin fa-fw"></i>
                    <i className={ category.icon }></i> {category.title}
                  </a>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

export default MediaSidebar;



// WEBPACK FOOTER //
// ./src/helpers/form/types/media-helper/MediaSidebar.js